const SettingsGetter = {
  settings: (state) => state.settings,
  transactionQueryParams: s => s.transactionQueryParams
};

export default SettingsGetter;
